import RestService from '@/api/rest-service/index'
export class AuthenticationService extends RestService {
  constructor() {
    super('auth')
  }
  login(data) {
    return this.makeRequest('post', `${this.namespace}/login`, data)
  }
  requestResetPassword(payload) {
    return this.makeRequest('post', `${this.namespace}/forgot`, payload)
  }
  resetPassword(payload) {
    return this.makeRequest('post', `${this.namespace}/reset`, payload)
  }
}
